import { AlertCircle } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

const Error = ({ title = 'Error', error = 'Something went wrong' }) => {
  return (
    <Alert variant="destructive">
      <AlertCircle size={18} />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{error}</AlertDescription>
    </Alert>
  );
};

export default Error;
